var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "observable",
      staticClass: "color-scroller",
      class: { visible: _vm.contentVisible },
    },
    [
      _c("div", {
        staticClass: "color-scroller__background",
        style: _vm.gradientStyle,
      }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }